module.exports = __webpack_public_path__ + "img/logo_secogey.3803b807.jpg";